/*
 *
 * OtpPopup
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 18-Jul-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  cardTitle: <PortalMessage id='t.app.verifyOtp.cardTitle' defaultMessage='Conferma il tuo numero di telefono.' />,
  cardSubTitle: (phoneNumber) => (
    <PortalMessage
      id='t.app.verifyOtp.cardSubTitle'
      defaultMessage='Inserisci il <strong>codice</strong> che ti abbiamo inviato via SMS al numero <strong>{phoneNumber}</strong>.'
      values={{
        phoneNumber
      }}
    />
  ),
  labelLink: <PortalMessage id='t.app.verifyOtp.labelLink' defaultMessage='Invia un nuovo codice' />,
  requiredError: <PortalMessage id='t.app.error.requiredField' defaultMessage='Il campo è obbligatorio' />,
  confirm: <PortalMessage id='t.app.confirm' defaultMessage='Conferma' />,
  verifyIdentity: (
    <PortalMessage id='t.app.verifyIdentity' defaultMessage='Verifica identità' />
  )
}

export default formattedMessage
